'use strict';

const jQuery = require('jquery');

const Container = require('./../../../core/container');

const zone = require('./../../../services/structure/zone');
const Translator = require('./../../../core/translator');
const FormBuilder = require('./../../../services/form');
const Notifier = require('./../../../services/notifier');
const Loader = require('./../../../services/loader');
const Help = require('./../../../services/help');

const UserPrefRepo = require('./../../content/repository/UserPreferenceRepository');

const onSubmit = function(data) {
    let robotsIndex = data['robots_index'];

    zone.hidePanels(Container.get('$smallPanel'));

    UserPrefRepo.save('search-engines', {'robots_index': robotsIndex}).done(function() {
        Notifier.success(Translator.translate('parameters_saved'));
    });
};

module.exports.onClick = function() {
    let $container = jQuery('<div></div>');

    let $layer = zone.addLayer(Translator.translate('website_on_google'), $container, {
        'extraTitle': Help.createLink('website_on_google'),
    });

    Loader.start($layer);

    UserPrefRepo.find('search-engines').done(function(data) {
        let form = FormBuilder.getForm({
            'elements': {
                'robots_index': {
                    'type': 'switch',
                    'label': Translator.translate('off'),
                    'value': Boolean(data['robots_index']),
                    'label_selected': Translator.translate('on'),
                },
            },
            'form': {
                'submit_class': 'd-none',
            },
        });

        $container.append('<p class="small">' + Translator.translate('website_on_google_message') + '</p>');
        $container.append(form.render());

        Loader.stop($layer);

        form.on('submit', onSubmit);

        zone.setFooter($layer, zone.createSubmitButtons({
            onSubmitClick: form.submit.bind(form),
        }));
    });
};
